import React, { type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import {
	FireScreenAnalytics,
	ContextualAnalyticsData,
	fireUIAnalytics,
	type Attributes,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import {
	type Props as OriginalProps,
	ItsmSpotlightCard,
} from '../../common/ui/itsm-spotlight-card/index.tsx';

type Props = OriginalProps & {
	sourceName: string;
	spotlightId: string;
};

export const AnalyticsSpotlightCard = ({ sourceName, spotlightId, buttons, ...props }: Props) => {
	const { primary, secondary, close } = buttons;
	const createAnalyticsButtonHandler =
		(
			handler: ((arg1: MouseEvent<HTMLElement>, arg2: UIAnalyticsEvent) => void) | null | undefined,
			attributes: Attributes,
		) =>
		(event: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, `${sourceName}Button`, attributes);
			handler && handler(event, analyticsEvent);
		};

	// Add analytics to passed in button handlers
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const buttonsWithAnalytics: Record<string, any> = {};
	if (close) {
		buttonsWithAnalytics.close = {
			...close,
			onClick: createAnalyticsButtonHandler(close.onClick, { buttonType: 'close' }),
		};
	}
	if (primary) {
		buttonsWithAnalytics.primary = {
			...primary,
			onClick: createAnalyticsButtonHandler(primary.onClick, {
				buttonType: 'primary',
			}),
		};
	}
	if (secondary) {
		buttonsWithAnalytics.secondary = {
			...secondary,
			onClick: createAnalyticsButtonHandler(secondary.onClick, {
				buttonType: 'secondary',
			}),
		};
	}

	return (
		<UFOSegment name="analytics-spot-light-card">
			<ContextualAnalyticsData
				sourceName={sourceName}
				sourceType={MODAL}
				attributes={{ spotlightId }}
			>
				<ItsmSpotlightCard {...props} buttons={buttonsWithAnalytics} />
				<FireScreenAnalytics key={spotlightId} />
			</ContextualAnalyticsData>
		</UFOSegment>
	);
};
